import type { App } from 'vue'
import { createPinia } from 'pinia'
import { initSentry } from '@/presentation/plugins/sentry.ts'
import { registerAuth0 } from '@/presentation/plugins/auth0.ts'
import { registerIconsToLibrary } from '@/presentation/plugins/icons.ts'
import nabooAdminRouter from '@/presentation/router'
import { registerMatomo } from '@/presentation/plugins/matomo.ts'
import Bootloader from '@/presentation/configuration/Bootloader.ts'
import { registerPrimeVueServices } from '@/presentation/plugins/primeVueServices.ts'
import { registerNabooDirectives } from '@/presentation/plugins/directives.ts'
import { registerNabooPrimeVueConfig } from '@/presentation/plugins/primeVue.ts'

export function registerPlugins(app: App) {
  // Router instance
  const routerInstance = nabooAdminRouter()

  // Plugins registration
  registerNabooPrimeVueConfig(app)
  registerIconsToLibrary()
  registerPrimeVueServices(app)
  registerMatomo(app, routerInstance)
  registerAuth0(app)

  // Create pinia instance
  app.use(createPinia())

  // Directives registration
  registerNabooDirectives(app)

  // Router registration
  app.use(routerInstance)

  // Sentry initialization
  initSentry(app, routerInstance)

  // Bootloader initialization
  Bootloader.initialize()
}
